import React  from "react"

export default function JsonLd() {
        return (
            `{
                "@context": "http://schema.org",
                "@type": "WebApplication",
                "name": "Edge.Poker",
                "url": "https://app.edge.poker",
                "description": "Edge.poker is the best online poker odds calculator & analyzer. Compute your winning odds, hand rank, optimal bet size and more when playing Texas Hold'Em.",
                "applicationCategory": "Calculator",
                "genre": "Poker",
                "about": {
                    "@type": "Thing",
                    "description": "calculator, analyzer, helper, poker odds, probability, chance, hand rank"
                },
                "browserRequirements": "Requires JavaScript. Requires HTML5.",
                "softwareVersion": "1.0.0",
                "softwareHelp": {
                    "@type": "CreativeWork",
                    "url": "https://app.edge.poker/how-to-use"
                },
                "operatingSystem": "All",
                "publisher": {
                    "@type" : "Organization",
                    "url" : "http://stockenja.com",
                    "name": "Stockenja"
                },
                "sameAs" : [
                    "https://www.facebook.com/edgepokerapp",
                    "https://twitter.com/EdgePokerApp"
                  ]
            }`
        )
}